import React, { useMemo } from 'react';
import { useLocale } from 'locale';
import { getCommercialProjectInfoLineConfig } from 'components/cards/new-layout/components/info-line-config';
import renderLineItem from 'components/labelLineItem';
import {
  PropertyPrimaryLine,
  PropertySecondaryLine,
  ProjectNameLabel,
} from 'components/cards/new-layout/styled';
import { SpacingBlock } from 'components/spacing-block';
import * as Styled from '../styled';
import { CommercialProjectUniversalCardProps } from 'components/cards/types';
import { removeDuplicatedCityFromNeighborhood } from 'utils/addressFormatter';

const CommercialProjectCard: React.FC<CommercialProjectUniversalCardProps> = (props) => {
  const {
    isPromoted,
    projectName,
    apartmentType,
    priceRange,
    floorRange,
  } = props;

  const localeProps = useLocale();
  const { t } = localeProps;

  const name = projectName ? projectName : t('universalCard.projectLabel.defaultName');
  const neighborhoodWithoutDuplicatedCity = removeDuplicatedCityFromNeighborhood(props.neighbourhood, props.city);

  const infoLineConfig = useMemo(() => {
    return getCommercialProjectInfoLineConfig(apartmentType, isPromoted, priceRange, floorRange, localeProps).filter(({ showCondition }) => showCondition);
  }, [ apartmentType, isPromoted, priceRange, floorRange, localeProps, getCommercialProjectInfoLineConfig ]);
  return (
    <>
      <SpacingBlock mLeft={5}>
        <ProjectNameLabel size="small" isPromoted={isPromoted}>
          {name}
        </ProjectNameLabel>
      </SpacingBlock>
      <SpacingBlock mTop={0.5}>
        <PropertySecondaryLine data-auto="property-address">
          {t('universalCard.project.address', {
            city: props.city || null,
            streetName: props.streetName || null,
            streetNumber: props.streetNumber || null,
            neighborhood: neighborhoodWithoutDuplicatedCity || null,
          })}
        </PropertySecondaryLine>
      </SpacingBlock>
      <Styled.PropertyInfoText>
        <PropertyPrimaryLine>
          {infoLineConfig.map(renderLineItem)}
        </PropertyPrimaryLine>
      </Styled.PropertyInfoText>
    </>
  );
};

export default CommercialProjectCard;
